import {
    PRODUCT_PRICING_FALLBACK_GET_SUCCESS,
    PRODUCT_PRICING_FALLBACK_GET_ERROR,
} from '../actionTypes/ProductPricingActionTypes';

function PricingFallBackReducer(state = {}, action) {
    switch (action.type) {
        case PRODUCT_PRICING_FALLBACK_GET_SUCCESS: {
            return {
                ...action.pricing,
                isError: false,
            };
        }
        case PRODUCT_PRICING_FALLBACK_GET_ERROR: {
            return {
                isError: true,
            };
        }
        default: {
            return state;
        }
    }
}

export default PricingFallBackReducer;
